<template>
  <v-window-item>
    <span class="h-warn" :class="warn.showText ? 'h-on' : 'h-off'" v-text="text" />
    <v-fade-transition>
      <v-icon v-show="warn.showIcon" small color="primary" v-text="icons.warning" />
    </v-fade-transition>
  </v-window-item>
</template>

<script>
  import { mapState } from 'vuex'
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import MenuChoice from '@/Models/Static/MenuChoice'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    props: {
      choice: {
        required: true,
        type: Number,
      },
      min: {
        required: true,
        type: Number,
      },
      max: {
        required: true,
        type: Number,
      },
    },

    data: () => ({
      MenuChoice,
    }),

    computed: {
      ...mapState('orders/menu', [
        'quantity',
        'warn',
      ]),
      text () {
        // copied from the Xef's APP
        if (this.isMultipleChoice == this.MenuChoice.SELECT_DEFAULT) {
          return this.__('defaultSelection')
        }
        if (this.min == 0 && this.max >= 100) {
          return this.__('optional')
        }
        if (this.min == 0) {
          return this.__('optionalUpTo').formatUnicorn(this.max * this.quantity)
        }
        if (this.min == this.max) {
          return this.__('selectQuantity').formatUnicorn(this.max * this.quantity)
        }
        return this.__('selectBetween').formatUnicorn(this.min * this.quantity, this.max * this.quantity)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .h-warn {
    transition: color .2s;
  }
  .h-on {
    color: black;
  }
  .h-off {
    color: grey;
  }
</style>
